"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CtaPopUp = void 0;
class CtaPopUp {
    static init() {
        const popUps = document.querySelectorAll('.js-ctaPopUpModal');
        Array.from(popUps).forEach((popUp) => {
            const uniqueName = popUp.id;
            document.querySelectorAll('a[href^="/' + uniqueName + '"]').forEach((block) => {
                block.setAttribute('data-toggle', 'modal');
                block.setAttribute('role', 'button');
                block.setAttribute('data-target', '.js-popUp-' + uniqueName);
                block.setAttribute('href', '#');
            });
        });
        CtaPopUp.downloadForm();
    }
    static downloadForm() {
        document.addEventListener('wpcf7mailsent', (event) => {
            if (event.target != null) {
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                const eventFormId = event.target.id;
                const form = document.getElementById(eventFormId);
                if (form != undefined) {
                    const download = form.nextElementSibling;
                    if (download != undefined) {
                        const file = download.getAttribute('data-file');
                        if (file != undefined) {
                            setTimeout(function () {
                                window.open(file, '_blank');
                            }, 1000);
                        }
                    }
                }
            }
        });
    }
}
exports.CtaPopUp = CtaPopUp;
